// generated by apiBaseUrl + "/tools/typescriptmodels"
import { EnvelopeDocument } from "./envelope-document";

export class ItemEnvelope {
	public constructor(jsonEnvelope: any, itemTypeName: string) {
		if (jsonEnvelope) {
			this.Document = { Item: jsonEnvelope.Document.Item };
		}
		this.ItemTypeName = itemTypeName;
	}
	public Document: EnvelopeDocument = new EnvelopeDocument();
	public ItemTypeName: string = "";
	public get ItemId(): number { return 0; }
	public get ItemName(): string { return ""; }
	public CreatedOnUTC?: Date;
	public CreateUserUID?: string;
	public ModifiedOnUTC?: Date;
	public ModifyUserUID?: string;
}